
import { defineComponent, PropType } from 'vue'
import { KeyMapper, PropertyField } from '@/modules/_shared/audit-log/types'
import { useAuditLogModule } from '@/modules/_shared/audit-log'
import AuditLogFieldTypesDisplayingValuesDefaultKey from '@/components/employees-audit-log/field-types/displaying-values/key.vue'
import AuditLogFieldTypesDisplayingValuesIndex from '@/components/employees-audit-log/field-types/displaying-values/index.vue'

export default defineComponent({
    name: 'audit-log-field-types-property',
    components: { AuditLogFieldTypesDisplayingValuesIndex, AuditLogFieldTypesDisplayingValuesDefaultKey },
    props: {
        field: {
            type: Object as PropType<PropertyField>,
            required: true
        },
        keyMapper: {
            type: Object as PropType<KeyMapper>,
            required: true
        }
    },
    setup () {
        const { aliasForKey } = useAuditLogModule()
        return {
            aliasForKey
        }
    }
})
